export const TAB_TRANSLTE_PREFIX = "contractSweepRecipientGroupTab";

export const EXPORT_FILE_NAME = `Contract Sweep Recipient Group Tab`;
